const animateImages = () => {
  const sections = document.querySelectorAll('.section-main-blog');

  sections.forEach((item) => {
    if (item.querySelectorAll('.observe-me').length > 0) {
      function createObserver() {
        function handleIntersect(entries, observer) {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              let css_classlist = entry.target.classList;
              css_classlist.add('is-inview');

              observer.unobserve(entry.target);

              setTimeout(() => {
                css_classlist.remove('is-inview');
                css_classlist.remove('observe-me');
              }, 1000); // Duration matches the animation duration in SCSS
            }
          });
        }

        let options = {
          root: null,
          rootMargin: '0px',
          threshold: 0.0,
        };

        let observer = new IntersectionObserver(handleIntersect, options);
        let targets = item.querySelectorAll('.observe-me');
        targets.forEach((target, index) => {
          observer.observe(target);
        });
      }

      createObserver();
    }
  });
};

const revealFirstPageLink = (button) => {
  const controls = button.closest('[data-load-more-controls]');
  const firstPageLink = controls?.querySelector('[data-go-first-page]');

  if (!firstPageLink) return;

  firstPageLink.hidden = false;
  firstPageLink.classList.remove('hidden');
};

const initFirstPageLinks = () => {
  document.querySelectorAll('[data-go-first-page]').forEach((link) => {
    if (link.dataset.firstPageBound === 'true') return;

    link.dataset.firstPageBound = 'true';

    link.addEventListener('click', (event) => {
      event.preventDefault();

      const collection = link.closest('.collection-product');
      const productGrid = collection?.querySelector('.load-more-grid');

      if (!productGrid) return;

      const prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      productGrid.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'start',
      });
    });
  });
};

const updateLoadMoreCount = (button) => {
  const collection = button.closest('.collection-product');
  const productGrid = collection?.querySelector('.load-more-grid');
  const countElement = collection?.querySelector('[data-load-more-count]');
  const countTemplateElement = collection?.querySelector(
    '[data-load-more-count-template]'
  );

  if (!productGrid || !countElement || !countTemplateElement) return;

  const viewedCount = productGrid.querySelectorAll(
    '.collection-product-card'
  ).length;

  const totalCount = Number.parseInt(
    countElement.dataset.totalCount,
    10
  );

  const countTemplate =
    countTemplateElement.content.textContent.trim();

  if (!Number.isFinite(totalCount) || !countTemplate) return;

  countElement.textContent = countTemplate
    .replaceAll('__VIEWED__', String(viewedCount))
    .replaceAll('__TOTAL__', String(totalCount));
};

const loadItems = (button) => {
  const totalPages = parseInt($('[data-total-pages]').val());
  let currentPage = parseInt($('[data-current-page]').val());
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage + 1;
  const nextUrl = $('[data-next-url]')
    .val()
    .replace(/page=[0-9]+/, 'page=' + currentPage);
  const nextUrlScroll = $('[data-next-url]')
    .val()
    .replace(/page=[0-9]+/, 'page=' + currentPageScroll);
  $('[data-current-page]').val(currentPage);

  button.setAttribute('disabled', '');
  button.classList.add('loading');

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function (responseHTML) {
    $('.load-more-grid').append($(responseHTML).find('.load-more-grid').html());
    revealFirstPageLink(button);
    updateLoadMoreCount(button);
    colorSwatches();
  },
    complete: function () {
      if (currentPage <= totalPages) {
        const scollData = document.querySelector('.infinite-scroll__data');
        if (scollData && currentPage != totalPages) {
          scollData.querySelector('input[data-next-url]').dataset.nextUrl = nextUrlScroll;
          scollData.querySelector('input[data-next-url]').value = nextUrlScroll;
          scollData.querySelector('input[data-current-page]').dataset.currentPage = currentPage;
          scollData.querySelector('input[data-current-page]').value = currentPage;
          checkVisibility();
        }
        button.removeAttribute('disabled');
        button.classList.remove('loading');
        if (currentPage == totalPages) {
          button.remove();
        }

        animateImages();
      }
    },
  });
};

const checkVisibility = () => {
  const spinnerList = document.querySelectorAll('.js-infinite-scroll');
  spinnerList.forEach((spinner) => {
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadItems(spinner);
          sectionObserver.unobserve(entry.target);
        }
      });
    });

    sectionObserver.observe(spinner);
  });
};

function loadMore() {
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    };
  });

  checkVisibility();
  animateImages();
  initFirstPageLinks();
}

(function () {
  loadMore();
})();
